module.exports = {
	"ha": "vcha",
	"id": 5.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 69.1588785046729,
						"dataLabels": {
							"enabled": true,
							"format": "148",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.55140186915887,
						"dataLabels": {
							"enabled": true,
							"format": "136",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 58.41121495327103,
						"dataLabels": {
							"enabled": true,
							"format": "125",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 51.86915887850467,
						"dataLabels": {
							"enabled": true,
							"format": "111",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 36.915887850467286,
						"dataLabels": {
							"enabled": true,
							"format": "79",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.0125786163522,
						"dataLabels": {
							"enabled": true,
							"format": "617",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.062893081761,
						"dataLabels": {
							"enabled": true,
							"format": "541",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.18867924528303,
						"dataLabels": {
							"enabled": true,
							"format": "510",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.64150943396226,
						"dataLabels": {
							"enabled": true,
							"format": "462",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 56.60377358490566,
						"dataLabels": {
							"enabled": true,
							"format": "360",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.66529774127311,
						"dataLabels": {
							"enabled": true,
							"format": "961",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.18891170431212,
						"dataLabels": {
							"enabled": true,
							"format": "820",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.82340862422998,
						"dataLabels": {
							"enabled": true,
							"format": "758",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.04722792607802,
						"dataLabels": {
							"enabled": true,
							"format": "692",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.874743326488705,
						"dataLabels": {
							"enabled": true,
							"format": "515",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 99.73727422003284,
						"dataLabels": {
							"enabled": true,
							"format": "3037",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.86371100164205,
						"dataLabels": {
							"enabled": true,
							"format": "2645",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.57635467980296,
						"dataLabels": {
							"enabled": true,
							"format": "2484",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.47126436781609,
						"dataLabels": {
							"enabled": true,
							"format": "2359",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 61.24794745484401,
						"dataLabels": {
							"enabled": true,
							"format": "1865",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -30.841121495327105,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.108108108108103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.088235294117652,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.2,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -28.828828828828833,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.9874213836478036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.317666126418148,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.7301293900184795,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.411764705882353,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -22.077922077922075,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.3347022587268942,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.672216441207075,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.560975609756094,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.70712401055409,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -25.57803468208093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -0.2627257799671545,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.90747448139612,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.086956521739129,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.032206119162641,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -20.94107672742688,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=214"
			},
			{
				"x": 9,
				"text": "30–39<br>n=636"
			},
			{
				"x": 15,
				"text": "40–49<br>n=974"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=3045"
			}
		],
		"dataTable": {
			"< 30": [
				214,
				148,
				136,
				125,
				111,
				79
			],
			"30–39": [
				636,
				617,
				541,
				510,
				462,
				360
			],
			"40–49": [
				974,
				961,
				820,
				758,
				692,
				515
			],
			"≥ 50": [
				3045,
				3037,
				2645,
				2484,
				2359,
				1865
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_3.json
// module id = 304
// module chunks = 0